import { useQuery } from 'react-query';
import { ParticipantsAPI } from 'api/participant';
import { PARTICIPANT } from 'helpers/constants';

export default function useParticipant(id) {
  return useQuery([PARTICIPANT, id], () => ParticipantsAPI.getById(id), {
    enabled: !!id,
  });
}
